var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAccuntSettings = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.08496 8.5C10.2941 8.5 12.085 6.70914 12.085 4.5C12.085 2.29086 10.2941 0.5 8.08496 0.5C5.87582 0.5 4.08496 2.29086 4.08496 4.5C4.08496 6.70914 5.87582 8.5 8.08496 8.5Z",
    fill: "#57585A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75496 9.52C8.53496 9.51 8.31496 9.5 8.08496 9.5C5.66496 9.5 3.40496 10.17 1.47496 11.32C0.594961 11.84 0.0849609 12.82 0.0849609 13.85V16.5H9.34496C8.55496 15.37 8.08496 13.99 8.08496 12.5C8.08496 11.43 8.33496 10.43 8.75496 9.52Z",
    fill: "#57585A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.835 12.5C18.835 12.28 18.805 12.08 18.775 11.87L19.915 10.86L18.915 9.13L17.465 9.62C17.145 9.35 16.785 9.14 16.385 8.99L16.085 7.5H14.085L13.785 8.99C13.385 9.14 13.025 9.35 12.705 9.62L11.255 9.13L10.255 10.86L11.395 11.87C11.365 12.08 11.335 12.28 11.335 12.5C11.335 12.72 11.365 12.92 11.395 13.13L10.255 14.14L11.255 15.87L12.705 15.38C13.025 15.65 13.385 15.86 13.785 16.01L14.085 17.5H16.085L16.385 16.01C16.785 15.86 17.145 15.65 17.465 15.38L18.915 15.87L19.915 14.14L18.775 13.13C18.805 12.92 18.835 12.72 18.835 12.5ZM15.085 14.5C13.985 14.5 13.085 13.6 13.085 12.5C13.085 11.4 13.985 10.5 15.085 10.5C16.185 10.5 17.085 11.4 17.085 12.5C17.085 13.6 16.185 14.5 15.085 14.5Z",
    fill: "#57585A"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAccuntSettings);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/AccuntSettings.8c399a252f88ad7e642f84c042349257.svg";